export const STRIPE_MARKETPLACE_PUBLISHABLE_KEY =
  process.env.REACT_APP_STRIPE_MARKETPLACE_PUBLISHABLE_KEY ??
  'test marketplace key';
